import {NavLink} from 'react-router-dom';
import styles from '../Header/Header.module.css';
import useDownloadsSummary from '../../hooks/useDownloadsSummary.hook';


export function AdminMenu() {
	const getClassName = ({isActive}) =>
		isActive ? `${styles['menu-item']} ${styles['menu-item-active']}` : styles['menu-item'];
	const {pending, ready_unseen} = useDownloadsSummary();
	const badge = ready_unseen || (pending ? '…' : null);

	return (
		<>
			<NavLink to={'/admin/users'} className={getClassName}>СОТРУДНИКИ</NavLink>
			<NavLink to={'/admin/workplaces'} className={getClassName}>РАБОЧИЕ МЕСТА</NavLink>
			<NavLink to={'/admin/education'} className={getClassName}>ЛНА</NavLink>
			<NavLink to={'/admin/SIZ'} className={getClassName}>СИЗ</NavLink>
			<NavLink to={'/admin/deadlines'} className={getClassName}>КОНТРОЛЬ СРОКОВ</NavLink>
			<NavLink to={'/admin/documents'} className={getClassName}>ДОКУМЕНТЫ</NavLink>
			<NavLink to={'/admin/downloads'} className={getClassName}>
				ЗАГРУЗКИ
				{badge && (
					<span
						className={styles['menu-badge']}
						title={pending ? `Формируется: ${pending}` : `Новых файлов: ${ready_unseen}`}
					>
						{badge}
					</span>
				)}
			</NavLink>
		</>
	);
}